import React from "react";
import { Box, Container } from "@mui/material";
import { ItemIssueReturnList } from "../../components/ItemIssueReturn/ItemIssueReturnList";

export const InvItemIssueReturnsPage = () => {
  return (
    <Box  
          sx={{
            minHeight:'100vh',
            background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
          }}
        >
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <ItemIssueReturnList />
      </Box>
    </Container>
    </Box>
  );
};
